import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="found fw-bold text-center">
            <h1 className="fs-10">404</h1>
            <h1>Page cannot found.</h1>
        </div>
    );
};

export default NotFound;